import React from "react";
import { Link } from "react-router-dom";
import "./components/Footer.css";

const loanLinks = [
  {
    label: "Home Loan",
    path: "/mortbuzz-home-loan",
  },
  {
    label: "Loan Against Property",
    path: "/mortbuzz-loan-against-property",
  },
  {
    label: "Commercial Loan",
    path: "/personal-loan",
  },
  {
    label: "Business Loan",
    path: "/business-loan",
  },
  {
    label: "Personal Loan",
    path: "/personal-loan",
  },
  {
    label: "Car Loan",
    path: "/car-loan",
  },
  {
    label: "Education Loan",
    path: "/education-loan",
  },
];

const companyLinks = [
  {
    label: "About Us",
    path: "/about",
  },
  {
    label: "Apply Now",
    path: "/apply-now",
  },
  {
    label: "Interest Rates",
    path: "/bank-interest-rates",
  },
  {
    label: "EMI Calculator",
    path: "/emi-calculator",
  },
  {
    label: "Frequently Asked Questions",
    path: "/faq",
  },
  {
    label: "Contact Us",
    path: "/contact",
  },
];

const legalLinks = [
  {
    label: "Privacy Policy",
    path: "/privacy-policy",
  },
  {
    label: "Terms and Conditions",
    path: "/terms-and-conditions",
  },
  {
    label: "Disclaimer",
    path: "/disclaimer",
  },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="monayra-footer">
      <div
        className="monayra-footer-glow monayra-footer-glow-left"
        aria-hidden="true"
      ></div>

      <div
        className="monayra-footer-glow monayra-footer-glow-right"
        aria-hidden="true"
      ></div>

      <div className="monayra-footer-container">
        <div className="monayra-footer-top">
          <div className="monayra-footer-brand-column">
            <Link
              to="/"
              className="monayra-footer-brand"
              aria-label="MONAYRA home"
            >
              <span className="monayra-footer-brand-icon">
                <i className="bi bi-buildings-fill"></i>
              </span>

              <span className="monayra-footer-brand-text">
                <strong>MONAYRA</strong>
                <small>(OPC) PRIVATE LIMITED</small>
              </span>
            </Link>

            <p className="monayra-footer-description">
              Professional assistance for home loans, personal loans,
              business loans, commercial loans, car loans, education loans
              and loans against property.
            </p>

            <div className="monayra-footer-trust-list">
              <div>
                <i className="bi bi-check-circle-fill"></i>
                Multiple lending partners
              </div>

              <div>
                <i className="bi bi-check-circle-fill"></i>
                Documentation assistance
              </div>

              <div>
                <i className="bi bi-check-circle-fill"></i>
                Support until disbursement
              </div>
            </div>

            <div className="monayra-footer-socials">
              <a
                href=""
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit MONAYRA on Facebook"
              >
                <i className="bi bi-facebook"></i>
              </a>

              <a
                href=""
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit MONAYRA on Instagram"
              >
                <i className="bi bi-instagram"></i>
              </a>

              <a
                href=""
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit MONAYRA on LinkedIn"
              >
                <i className="bi bi-linkedin"></i>
              </a>

              <a
                href=""
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit MONAYRA on YouTube"
              >
                <i className="bi bi-youtube"></i>
              </a>
            </div>
          </div>

          <div className="monayra-footer-links-column">
            <h2>Loan Products</h2>

            <ul>
              {loanLinks.map((item) => (
                <li key={item.label}>
                  <Link to={item.path}>
                    <i className="bi bi-chevron-right"></i>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="monayra-footer-links-column">
            <h2>Quick Links</h2>

            <ul>
              {companyLinks.map((item) => (
                <li key={item.label}>
                  <Link to={item.path}>
                    <i className="bi bi-chevron-right"></i>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="monayra-footer-contact-column">
            <h2>Contact Us</h2>

            <div className="monayra-footer-contact-list">
              <a href="mailto:contact@monayra.in">
                <span className="monayra-footer-contact-icon">
                  <i className="bi bi-envelope"></i>
                </span>

                <span>
                  <small>General Enquiry</small>
                  <strong>contact@monayra.com</strong>
                </span>
              </a>

              <a href="mailto:support@mortbuzz.in">
                <span className="monayra-footer-contact-icon">
                  <i className="bi bi-headset"></i>
                </span>

                <span>
                  <small>Customer Support</small>
                  <strong>support@monayra.com</strong>
                </span>
              </a>

              <a href="tel:+912079637941">
                <span className="monayra-footer-contact-icon">
                  <i className="bi bi-telephone"></i>
                </span>

                <span>
                  <small>Office Number</small>
                  <strong>--------------</strong>
                </span>
              </a>

              <a href="tel:18002104422">
                <span className="monayra-footer-contact-icon">
                  <i className="bi bi-telephone-inbound"></i>
                </span>

                <span>
                  <small>Toll-Free Support</small>
                  <strong>------------</strong>
                </span>
              </a>
            </div>
          </div>
        </div>

        <div className="monayra-footer-location-row">
          <div className="monayra-footer-address">
            <span className="monayra-footer-location-icon">
              <i className="bi bi-geo-alt-fill"></i>
            </span>

            <div>
              <small>Visit Our Office</small>

              <address>
          
                Head Brach Mumbai, Maharashtra
              </address>
            </div>
          </div>

          <div className="monayra-footer-cta">
            <div>
              <span>Ready to begin?</span>

              <h3>Turn your financial goals into reality.</h3>
            </div>

            <Link to="/apply-now" className="monayra-footer-apply-btn">
              Apply Now
              <i className="bi bi-arrow-right"></i>
            </Link>
          </div>
        </div>

        <div className="monayra-footer-divider"></div>

        <div className="monayra-footer-bottom">
          <p>
            © {currentYear}{" "}
            <strong>MONAYRA (OPC) PRIVATE LIMITED</strong>. All rights
            reserved.
          </p>

          <nav
            className="monayra-footer-legal-links"
            aria-label="Legal links"
          >
            {legalLinks.map((item) => (
              <Link to={item.path} key={item.label}>
                {item.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="monayra-footer-disclaimer">
          <i className="bi bi-info-circle"></i>

          <p>
            MONAYRA (OPC) PRIVATE LIMITED provides loan assistance and
            facilitates applications with lending institutions. Final
            approval, interest rates, tenure, loan amount and applicable
            charges are determined by the selected lender based on its
            policies and the applicant’s eligibility.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;